import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();

  console.error(error);

  return (
    <div style={{
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      fontFamily: "Arial"
    }}>
      <h1>⚠️ Algo deu errado</h1>
      <p>Ocorreu um erro ao carregar esta página.</p>
      <button onClick={() => window.location.reload()}>
        Recarregar página
      </button>
    </div>
  );
}